import get from 'axios'

export const getCEP = cep =>
  get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`, {
    ignoreAuth: true,
  })
    .then(r => r.data)
    .catch(() => false)

export default { getCEP }
